import { useQuery } from "@tanstack/react-query";
import { previewWaitlistInvite } from "@/adapters/api";

export function useWaitlistInvitePreview(token: string | undefined) {
	return useQuery({
		queryKey: ["waitlist-invite", token],
		queryFn: () => previewWaitlistInvite(token as string),
		enabled: token != null,
		retry: false,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});
}
